import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { connect } from 'react-redux';


let InputDateTime = ({activeDate, neverDisable, values, radioName, input, placeholder, type,  min, max, meta: { touched, error } }) => {
  let defaultDate  = activeDate ? moment(activeDate, 'YYYY/MM/DD HH:mm:ss').format('DD/MM/YYYY')  : null;
  defaultDate  = defaultDate ? moment(defaultDate, 'DD/MM/YYYY' ) : moment()

  return (
    <div>
      <DatePicker {...input} type={type} autoComplete="off" placeholderText={activeDate ? moment(activeDate, 'YYYY/MM/DD HH:mm:ss').format('DD/MM/YYYY') : placeholder}  minDate={ min }  min={min} max={max}   dateFormat='DD/MM/YYYY'  selected={input.value ? moment(input.value, 'DD/MM/YYYY')  :  defaultDate} disabled={!(neverDisable || values[radioName] === "option2")} />
      {touched && error && <div><span className="text-danger">{error}</span></div>}
    </div>
  );
}
const viewMapStateToProps = (state) => {
  return {

  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
  };
};

InputDateTime = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(InputDateTime);

export default InputDateTime;



// WEBPACK FOOTER //
// ./src/lib/forms/inputDateTime.js